module.exports = __webpack_public_path__ + "static/media/photo.2932b24f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/elements/screen-images/photography/photo.jpg
// module id = 724
// module chunks = 0